module.exports = __webpack_public_path__ + "37ffb03a57d7861cb325594016672fbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/welcome/img/background.jpg
// module id = 3Hj3
// module chunks = 3